import { render } from "./CategoriesDetails.vue?vue&type=template&id=2cd802b3&scoped=true"
import script from "./CategoriesDetails.vue?vue&type=script&lang=js"
export * from "./CategoriesDetails.vue?vue&type=script&lang=js"

import "./CategoriesDetails.vue?vue&type=style&index=0&id=2cd802b3&scoped=true&lang=scss"

import exportComponent from "D:\\CTS_SURAJ\\Tracker Eticket\\Tracker_Eticket\\ui-code\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2cd802b3"]])

export default __exports__